

const SettingsRouteList = {
    addOrEdit:"add-or-edit",
    postOffice:"postOffice",
    userList:"user",
    userGroup:"user-group",
    BackUp: "backup",
    clinicManagement:"clinic-management",
    userManageMent:"user-management",
    expenseManager:"expense-manager",
    feedbackList:"patient-feedback-list",
}

export default SettingsRouteList;